import {
  dialogContentClasses,
  inputBaseClasses,
  selectClasses,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const name = 'AddNetworkDialog';

export const useAddNetworkDialogStyles = makeStyles({ name })(theme => ({
  paper: {
    minWidth: 600,

    [`.${dialogContentClasses.root}`]: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
    },

    [theme.breakpoints.down('sm')]: {
      minWidth: 'unset',
      width: '100%',
    },
  },
  addNetworkChainSelector: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  placeholder: {
    width: 38,

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  classNameSelector: {
    width: '100%',
  },
  classNameFirstTabsWrapper: {
    width: '100%',
    height: 40,
  },
  classNameFirstTabsInner: {
    flex: 1,
    height: 40,
  },
  classNameGroupSelectorRoot: {
    '&&&': {
      width: '100%',

      [`.${inputBaseClasses.root}`]: {
        width: '100%',
        height: 40,
      },

      [`.${selectClasses.select}`]: {
        width: '100%',
      },
    },
  },
  buttonRoot: {
    width: '100%',
  },
}));
